"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalMenuNav = exports.ModalRoot = exports.Label = exports.BurgerMenuWithJoinIconContainer = exports.BurgerMenuRoot = exports.BurgerMenuInner = exports.BurgerMenuContentRoot = exports.BurgerMenuContainer = exports.BurgerMenuBackdrop = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _styles = require("../styles");
var _constants = require("./constants");
const BurgerMenuContentRoot = exports.BurgerMenuContentRoot = (0, _mui.styled)('div')(() => ({}));
const ModalRoot = exports.ModalRoot = (0, _mui.styled)(_components.Modal)(({
  theme
}) => ({
  ..._styles.basePositionStyles,
  zIndex: theme.zIndex.drawer,
  display: 'block'
}));
const BurgerMenuRoot = exports.BurgerMenuRoot = (0, _mui.styled)('aside', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isMobile,
  isDesktop,
  isTopAreaNavigationVisible,
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  display: 'none',
  transition: `top ${_presentationUtils.CSS_HEIGHT_ANIMATION}`,
  ...(isMobile && {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    maxWidth: 'calc(100% - 45px)',
    position: 'absolute',
    width: 315
  }),
  ...(isDesktop && {
    boxShadow: _mui.SHADOW_LEVEL1,
    display: 'flex',
    left: 0,
    minHeight: `min(590px, ${_constants.DESKTOP_BURGER_MENU_HEIGHT})`,
    position: 'absolute',
    // istanbul ignore next -- temporary solution until TopAreaNavigation is rolled out everywhere
    top: `calc(${_presentationUtils.CSS_DESKTOP_INNER_HEIGHT} + ${isTopAreaNavigationVisible ? _presentationUtils.TOP_AREA_NAVIGATION_HEIGHT : 0}px)`
  })
}));
const BurgerMenuInner = exports.BurgerMenuInner = (0, _mui.styled)('div')(({
  theme
}) => ({
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
    width: 'inherit',
    maxHeight: _constants.DESKTOP_BURGER_MENU_HEIGHT,
    overflowX: 'hidden',
    overflowY: 'auto'
  }
}));
const BurgerMenuContainer = exports.BurgerMenuContainer = (0, _mui.styled)('div')({
  display: 'flex',
  height: 54,
  width: '100%'
});
const BurgerMenuBackdrop = exports.BurgerMenuBackdrop = (0, _mui.styled)(_mui.Backdrop)({
  position: 'absolute',
  zIndex: '-1',
  width: '100vw',
  height: '100vh'
});
const BurgerMenuWithJoinIconContainer = exports.BurgerMenuWithJoinIconContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2)
}));
const Label = exports.Label = (0, _mui.styled)(_mui.Typography)({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  userSelect: 'none',
  textTransform: 'uppercase'
});
const PersonalMenuNav = exports.PersonalMenuNav = (0, _mui.styled)('nav')({
  overflow: 'auto',
  height: '100%',
  flex: 1
});
